import React, { useEffect, useRef, useState } from 'react';

const ChatPage = () => {
  // Get chatbot configuration from environment variables
  const CHATBOT_ID = process.env.REACT_APP_CHATBASE_ID;
  const CHATBASE_DOMAIN = process.env.REACT_APP_CHATBASE_DOMAIN || 'www.chatbase.co';
  
  const [isLoaded, setIsLoaded] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    // Prevent body scroll when chat page is active
    document.body.style.overflow = 'hidden';
    
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  useEffect(() => {
    if (!CHATBOT_ID || CHATBOT_ID === 'YOUR_CHATBOT_ID') return;

    // Set the chatbot config
    window.embeddedChatbotConfig = {
      chatbotId: CHATBOT_ID,
      domain: CHATBASE_DOMAIN
    };

    // Load the Chatbase script
    const script = document.createElement('script');
    script.src = `https://${CHATBASE_DOMAIN}/embed.min.js`;
    script.setAttribute('chatbotId', CHATBOT_ID);
    script.setAttribute('domain', CHATBASE_DOMAIN);
    script.defer = true;
    
    script.onload = () => {
      setIsLoaded(true);
    };

    script.onerror = () => {
      console.error('Failed to load Chatbase script');
    };

    document.body.appendChild(script);

    // Cleanup
    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
      // Remove the chatbot widget if it exists
      const chatWidget = document.getElementById('chatbase-bubble-button');
      if (chatWidget) {
        chatWidget.remove();
      }
      const chatWindow = document.getElementById('chatbase-bubble-window');
      if (chatWindow) {
        chatWindow.remove();
      }
    };
  }, [CHATBOT_ID, CHATBASE_DOMAIN]);

  // Show message if chatbot ID is not configured
  if (!CHATBOT_ID || CHATBOT_ID === 'YOUR_CHATBOT_ID') {
    return (
      <div 
        style={{
          width: '100vw',
          height: '100vh',
          margin: 0,
          padding: 0,
          position: 'fixed',
          top: 0,
          left: 0,
          zIndex: 9999,
          backgroundColor: '#f5f5f5',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          fontFamily: 'Arial, sans-serif'
        }}
      >
        <div style={{
          textAlign: 'center',
          padding: '2rem',
          backgroundColor: '#ffffff',
          borderRadius: '8px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          maxWidth: '500px'
        }}>
          <h2 style={{ marginBottom: '1rem', color: '#333' }}>Chatbot Not Configured</h2>
          <p style={{ color: '#666', marginBottom: '1rem' }}>
            Please add your Chatbase chatbot ID to your <code>.env</code> file:
          </p>
          <code style={{
            display: 'block',
            padding: '1rem',
            backgroundColor: '#f0f0f0',
            borderRadius: '4px',
            fontSize: '0.9rem'
          }}>
            REACT_APP_CHATBASE_ID=sAZzCWUMAsbCWU8iGOCJg
          </code>
        </div>
      </div>
    );
  }

  return (
    <div 
      ref={containerRef}
      style={{
        width: '100vw',
        height: '100vh',
        margin: 0,
        padding: 0,
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 9999,
        backgroundColor: '#ffffff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      {!isLoaded && (
        <div style={{ textAlign: 'center', color: '#666' }}>
          <p>Loading chatbot...</p>
        </div>
      )}
    </div>
  );
};

export default ChatPage;